"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("../../xs/services/events/application-events.service");
const i2 = require("../../commons/map.service");
const i3 = require("../feature-detector.service");
const i4 = require("../measurement-helper.service");
const i5 = require("@angular/material/snack-bar");
DEBUG_1.DEBUG.open('/service/controllers/scene-controller.ts');
const _ = require("lodash");
const Constants_1 = require("../../commons/Constants");
const map_service_1 = require("../../commons/map.service");
const States_1 = require("../../commons/States");
const _4d_mapper_1 = require("4d-mapper");
const event_listener_interface_1 = require("@src/app/xs/interfaces/event-listener.interface");
const identify_interface_1 = require("@src/app/xs/interfaces/identify.interface");
const application_events_service_1 = require("@src/app/xs/services/events/application-events.service");
const feature_detector_service_1 = require("../feature-detector.service");
const measurement_helper_service_1 = require("../measurement-helper.service");
const entities_renderer_class_1 = require("@src/app/xs/controllers/entities-renderer.class");
const await_class_1 = require("@src/app/xs/controllers/await.class");
const material_1 = require("@angular/material");
/*
  The SceneController is a reporting hub for other services and components
  to get information about things in the current scene, like layers, important
  properties of those, annotations, filters and active plugins
*/
class SceneControllerService {
    constructor(applicationEvents, mapService, featureDetector, measureHelper, _snackBar) {
        this.applicationEvents = applicationEvents;
        this.mapService = mapService;
        this.featureDetector = featureDetector;
        this.measureHelper = measureHelper;
        this._snackBar = _snackBar;
        this.__ID = null;
        this.__EVENTS = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugReport = Constants_1.Constants.debug_off;
        this.debugPrimary = Constants_1.Constants._green;
        this.debugSecondary = Constants_1.Constants._black;
        // these renderers plot and unplot entities to the map
        this.transforms = new entities_renderer_class_1.EntitiesRenderer();
        this.annotations = new entities_renderer_class_1.EntitiesRenderer();
        this.images = new entities_renderer_class_1.EntitiesRenderer();
        // only the plotted Transforms on the map
        this.plottedTransforms = [];
        // layer reporting
        this.activeTransforms = {};
        this.activePlugins = {};
        this.activeTerrain = {};
        this.activeCameraPositions = null;
        // generic state reporting
        this.anyPointclouds = false;
        this.anyTransparentItems = false;
        this.anyTransparentTerrain = false;
        this.anyTerrain = false;
        // list of state item reporting
        this.transparentTerrains = {};
        this.transparentItems = {};
        this.pointClouds = {};
        this.terrains = {};
        // action list; every scene change instills a set of actions (mostly camera flying, but it could be anything; plugins can interact with this API)
        this.actions = {};
        // last action reporting
        this.complexActionLog = [];
        this.callbacks = {};
        this.callbacksReturn = {};
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        DEBUG_1.DEBUG.log('/service/controllers/scene-controller.service.ts', 'services');
        // let me = this;
        // slightly delayed init
        setTimeout(() => { this.init(); }, 200);
    }
    registerAction(key, data) {
        this.actions[key] = data;
    }
    init() {
        // subscribe to the main scene changing event
        this.applicationEvents.subscribe(
        // when the scene has changed (loaded different, or a brand new one)
        this.mapService.onSceneChange('scene-controller').subscribe(scene => {
            if (this.debug) {
                console.log('%c sceneController %c mapService.subscribe()', this.debugPrimary, this.debugSecondary, scene.id);
            }
            this.sceneChange(scene);
        }), 'mapService-onSceneChange');
    }
    // hook into the End scene change event from old mapService
    ___mapServiceSceneChangeStart(scene = null) {
        if (this.debug) {
            console.log('%c sceneController %c ___mapServiceSceneChangeStart (currently do nothing)', this.debugPrimary, this.debugSecondary, scene);
        }
        // this.sceneChangeInit();
    }
    // hook into the End scene change event from old mapService
    ___mapServiceSceneChangeEnd(scene = null) {
        if (this.debug) {
            console.log('%c sceneController %c ___mapServiceSceneChangeEnd', this.debugPrimary, this.debugSecondary, scene);
        }
        this.sceneChange(scene);
    }
    /*
    // hook into the End scene change event from old mapService
    ___mapServicePhotosChangeStart () {
      if ( this.debug ) { console.log ( '%c sceneController %c ___mapServicePhotosChangeStart, converting old to new', this.debugPrimary, this.debugSecondary ); }
    }
    ___mapServicePhotosChangeEnd (photos:any[] = null ) {
      if ( this.debug ) { console.log ( '%c sceneController %c ___mapServicePhotosChangeEnd, converting old to new', this.debugPrimary, this.debugSecondary, photos ); }
    }
  
    // hook into the End scene change event from old mapService
    ___mapServiceAnnotationsChangeStart (annotations:any[] = null ) {
      if ( this.debug ) { console.log ( '%c sceneController %c ___mapServiceAnnotationsChangeStart, converting old to new', this.debugPrimary, this.debugSecondary, annotations ); }
    }
  
    // hook into the End scene change event from old mapService
    ___mapServiceTransformsChangeStart () {
      if ( this.debug ) { console.log ( '%c sceneController %c ___mapServiceAnnotationsChangeStart, converting old to new', this.debugPrimary, this.debugSecondary ); }
    }
    ___mapServiceTransformsChangeEnd (transforms:any[] = null ) {
      if ( this.debug ) { console.log ( '%c sceneController %c ___mapServiceAnnotationsChangeEnd, converting old to new', this.debugPrimary, this.debugSecondary, transforms ); }
    }
  */
    ___mapViewerDestroyStart(obj = null) {
        if (this.debug) {
            console.log('%c scene-controller %c ___mapViewerDestroyStart', this.debugPrimary, this.debugSecondary, obj);
        }
        this.sceneDestroy().then(_ => {
            if (this.debug) {
                console.log('%c scene-controller %c ___mapViewerDestroyStart DESTROYED SCENE', this.debugPrimary, this.debugSecondary, obj);
            }
        });
    }
    clearScene() {
        if (this.debug) {
            console.log('%c sceneController %c clearScene()', this.debugPrimary, this.debugSecondary);
        }
        // clear out all callbacks and callbackReturns
        this.callbacks = {};
        this.callbacksReturn = {};
        // clear our lookup objects
        this.activeTransforms = {};
        this.activeTerrain = {};
        this.transparentTerrains = {};
        this.transparentItems = {};
        this.pointClouds = {};
        this.activeCameraPositions = {
            counter: 0
        };
        // clear overall state
        this.anyPointclouds = false;
        this.anyTerrain = false;
        this.anyTransparentItems = false;
        this.anyTransparentTerrain = false;
        // clear the action commands
        this.actions = {};
    }
    // capture various events, and deal with them
    ___sceneChangeInit(scene) {
        if (this.debug) {
            console.log('%c sceneController %c ___SCENE_CHANGE init', this.debugPrimary, this.debugSecondary);
        }
        Constants_1.Constants.showHangOn();
        // clear our reporting data
        this.clearScene();
    }
    ___sceneChangeStart(scene) {
        if (this.debug) {
            console.log('%c sceneController %c ___SCENE_CHANGE start', this.debugPrimary, this.debugSecondary);
        }
        // if it is not defined then set it; various properties for our layers / transforms
        if (!scene['layerProps']) {
            scene['layerProps'] = {};
        }
        this.checkForCameraBookmarks('scene', scene);
    }
    ___sceneChangeProcess(scene) {
        if (this.debug) {
            console.log('%c sceneController %c ___SCENE_CHANGE process', this.debugPrimary, this.debugSecondary);
        }
        let cam = this.fetchCameraBookmark();
        if (cam.camera) {
            this.registerAction(Constants_1.SceneActions.flyCamera, cam.camera);
        }
        else {
            let fromThese = this.mapService.sceneTransforms.filter(t => this.mapService.scene['layerProps'][map_service_1.MapService.TOGGLE + t.id]);
            if (fromThese && fromThese.length) {
                let t = fromThese[0];
                if (t['ds_type_uid'] == 'kml' || t['ds_type_uid'] == 'geo-json') {
                    this.registerAction(Constants_1.SceneActions.flyCameraReady, t);
                }
                else {
                    this.registerAction(Constants_1.SceneActions.flyCamera, t);
                }
            }
        }
        // check and do only flying if there are any
        this.checkAndDoActions(Constants_1.SceneActions.flyCamera);
    }
    ___sceneChangeEnd(scene) {
        if (this.debug) {
            console.log('%c sceneController %c ___SCENE_CHANGE end', this.debugPrimary, this.debugSecondary);
        }
        Constants_1.Constants.hideHangOn();
        // check and do only flying here when the Scene is ready
        this.checkAndDoActions(Constants_1.SceneActions.flyCameraReady);
    }
    checkAndDoActions(key) {
        if (this.actions[key]) {
            switch (key) {
                // flying
                case Constants_1.SceneActions.flyCamera:
                case Constants_1.SceneActions.flyCameraReady:
                    this.flyTo(this.actions[key]);
                    break;
            }
            this.actions[key] = null;
            delete this.actions[key];
        }
    }
    // big sceneChange starts here (and from here we fire off events)...
    sceneChange(scene) {
        if (this.debug) {
            console.log('%c sceneController %c sceneChange() (await)', this.debugPrimary, this.debugSecondary, scene.id);
        }
        // make sure we've got a Cesium viewer before we start plotting stuff to the map
        await_class_1.XsAwait.until(['mapService.viewer', 'mapService.helper', 'mapService.currentProject'], this).then(_ => {
            this.sceneChangeAction(scene);
        });
    }
    sceneChangeAction(scene) {
        const me = this;
        if (this.debug) {
            console.log('%c sceneController %c sceneChangeAction() init', this.debugPrimary, this.debugSecondary, scene.id);
        }
        this.applicationEvents.triggerInit('sceneChange', null, this.__ID);
        // deal with incoming transforms
        let incomingTransforms = this.mapService.sceneTransforms.filter(p => scene['layerProps'][map_service_1.MapService.TOGGLE + p.id]);
        let transformsToCreate = incomingTransforms.filter(p => !this.plottedTransforms.find(s => p.id == s.id));
        let transformsToRemove = this.plottedTransforms.filter(p => !incomingTransforms.find(s => p.id == s.id));
        if (this.debug) {
            console.log('%c sceneController %c sceneChangeAction() start', this.debugPrimary, this.debugSecondary, scene.id, incomingTransforms, transformsToCreate, transformsToRemove);
        }
        this.applicationEvents.triggerStart('sceneChange', scene, this.__ID);
        const test = new Promise(resolve => {
            // assume done (there might be no items to process), but if it starts to remove/create we're back to not being done
            let removeDone = true;
            let createDone = true;
            let countToRemove = 0;
            let countToCreate = 0;
            // console.log ( '%c ##_transformsRender STARTING ', Constants._red );
            // any transforms to remove?
            if (transformsToRemove.length) {
                // console.log ( '%c ##_transformsRender REMOVE START ', Constants._red );
                // remove those who shan't be seen
                transformsToRemove.forEach(t => {
                    removeDone = false;
                    me.unplotTransform(t).then(tt => {
                        countToRemove++;
                        // are we done removing?
                        if (countToRemove == transformsToRemove.length) {
                            removeDone = true;
                            if (this.debug) {
                                console.log('%c sceneController %c sceneChangeAction() DONE (remove)', this.debugPrimary, this.debugSecondary);
                            }
                        }
                        if (removeDone && createDone) {
                            // console.log ( '%c ##_transformsRender REMOVE END', Constants._red );
                            resolve(scene);
                        }
                    });
                });
            }
            // any transforms to add?
            if (transformsToCreate.length) {
                // console.log ( '%c ##_transformsRender CREATE START ', Constants._red );
                // plot on the map the new ones
                transformsToCreate.forEach(t => {
                    createDone = false;
                    let time = 0;
                    setTimeout(() => {
                        me.plotTransform(t).then(tt => {
                            countToCreate++;
                            time = countToCreate * 200;
                            // are we done adding?
                            if (countToCreate == transformsToCreate.length) {
                                createDone = true;
                                if (this.debug) {
                                    console.log('%c sceneController %c sceneChangeAction() DONE (create)', this.debugPrimary, this.debugSecondary);
                                }
                            }
                            if (removeDone && createDone) {
                                // console.log ( '%c ##_transformsRender CREATE END ', Constants._red );
                                resolve(scene);
                            }
                        });
                    }, time);
                });
            }
            // quick check to see if we needed to do anything, otherwise just resolve straight away
            if (removeDone && createDone) {
                // console.log ( '%c ##_transformsRender ENDING ', Constants._red );
                resolve(scene);
            }
            // all plottables are plotting, and we know all the transforms and stuff, so trigger!
            setTimeout(() => {
                if (this.debug) {
                    console.log('%c sceneController %c sceneChangeAction() process', this.debugPrimary, this.debugSecondary);
                }
                this.applicationEvents.triggerProcess('sceneChange', scene, this.__ID);
            }, 40);
        }).then(_ => {
            setTimeout(() => {
                if (this.debug) {
                    console.log('%c sceneController %c sceneChangeAction() end', this.debugPrimary, this.debugSecondary);
                }
                this.applicationEvents.triggerEnd('sceneChange', scene, this.__ID);
            }, 60);
        });
    }
    sceneDestroy() {
        let me = this;
        const test = new Promise(resolve => {
            // assume done (there might be no items to process), but if it starts to remove/create we're back to not being done
            let removeDone = true;
            let countToRemove = 0;
            // console.log ( '##_transformsToRemove START');
            // remove those who shan't be seen
            this.plottedTransforms.forEach(t => {
                removeDone = false;
                me.unplotTransform(t).then(tt => {
                    countToRemove++;
                    // are we done removing?
                    if (countToRemove == this.plottedTransforms.length) {
                        removeDone = true;
                    }
                    if (removeDone) {
                        // console.log ( '##_transformsToRemove END');
                        resolve(null);
                    }
                });
            });
        }).then(_ => {
            me.plottedTransforms = [];
        });
        return test;
    }
    loadScene(id, mustReload) {
        if (this.debug) {
            console.log('sceneController :: loadScene()', id);
        }
        // this.v2MapDataService.onSceneReady().subscribe(_ => {
        if (this.mapService.scene.id == id && !mustReload)
            return;
        this.mapService.flyToFirstTransform = mustReload;
        //enable zoom because for tetrageo zip file we are forcefully disabling zoom function.
        this.mapService.viewer.scene.screenSpaceCameraController.enableZoom = true;
        // reset the feature detector (freeing up test-slots for smooth testing of content)
        this.featureDetector.reset();
        // Go on! Load it!
        this.mapService.loadScene(id, mustReload).subscribe();
        // double hatting, but cant quite replace old one yet!
        // this.v2MapDataService.loadScene(id).subscribe();
        // });
    }
    callback(token, t, c) {
        this.callbacks[t.id] = token;
        if (!this.callbacksReturn[t.id]) {
            this.callbacksReturn[t.id] = {};
        }
        this.callbacksReturn[t.id][token] = c;
        // console.log('%c #callbackOn ['+token+'] for ['+t.id+'] ',Constants._black, c);
        // if ( c && token == 'start' ) { this.checkAndHook(c,token,t); };
    }
    // plotting / processing
    plottingTransform(resolve, t, s = null) {
        const token = 'plotTransform';
        // console.log('## plotting ...', s );
        this.featureDetector.checkTransform(t, { object: s }).then(meta => {
            this.applicationEvents.triggerDuring(token, t, this.__ID);
            // resolve(t);
        });
    }
    plotTransform(t) {
        let me = this;
        const token = 'plotTransform';
        if (this.debug) {
            console.log('%c sceneController %c plotTransform()', this.debugPrimary, this.debugSecondary, t);
        }
        me.applicationEvents.triggerInit(token, t, me.__ID);
        me.checkForCameraBookmarks('transform', t);
        return new Promise(resolve => {
            let args = {
                onInit: function (T, S) { me.callback('init', T, S); },
                onStart: function (T, S) { me.callback('start', T, S); },
                onProcess: function (T, S) { me.callback('process', T, S); },
                onDuring: function (T, S) { me.callback('during', T, S); },
                onEnd: function (T, S) { me.callback('end', T, S); }
            };
            if (t.transformType.uid == 'kml' || t.transformType.uid == 'geo-json') {
                if (!t.hasOwnProperty('clamping')) {
                    if (t.transformType.uid == 'kml') {
                        t['clamping'] = true;
                    }
                    else {
                        t['clamping'] = false;
                    }
                }
                args['clamping'] = t['clamping'];
            }
            args.onProcess = function (T, S) { me.plottingTransform(resolve, T, S); };
            me.applicationEvents.triggerStart(token, t, me.__ID);
            me.mapService.helper.setPlottable(t, args).subscribe(p => {
                let find = me.plottedTransforms.find(pt => pt.id == t.id);
                if (!find) {
                    me.plottedTransforms.push(t);
                    if (me.debug) {
                        console.log('%c sceneController %c plotTransform() added to plottables', me.debugPrimary, me.debugSecondary, t);
                    }
                }
                // me.applicationEvents.triggerEnd ( token, t, me.__ID );
                // resolve(t);
                if (p) {
                    let pp = p.plottable;
                    me.featureDetector.checkTransform(pp).then(meta => {
                        // any auto-zoom requests? These usually comes from incoming / uploading / processing data files
                        if (pp && pp.input && pp.input['__auto_zoom_to']) {
                            // attach it to 'ready', as the more immediate mode has passed...
                            me.registerAction(Constants_1.SceneActions.flyCameraReady, pp);
                            // remember to remove to auto-zoom
                            pp.input['__auto_zoom_to'] = false;
                            pp.input.saveObservable().subscribe();
                            if (me.debug) {
                                console.log('%c sceneController %c plotTransform() added auto-zoom', me.debugPrimary, me.debugSecondary, pp);
                            }
                        }
                        me.applicationEvents.triggerEnd(token, t, me.__ID);
                        resolve(t);
                    });
                }
            });
        });
    }
    unplotTransform(t) {
        const me = this;
        const token = 'unplotTransform';
        if (this.debug) {
            console.log('%c sceneController %c unplotTransform()', this.debugPrimary, this.debugSecondary, t);
        }
        me.applicationEvents.triggerInit(token, t, me.__ID);
        me.removeCameraBookmarks('transform', t);
        return new Promise(resolve => {
            me.applicationEvents.triggerStart(token, t, me.__ID);
            me.mapService.helper.removePlottable(t);
            let find = me.plottedTransforms.find(pt => pt.id == t.id);
            if (find) {
                me.plottedTransforms = me.plottedTransforms.filter(pt => pt.id !== t.id);
                if (me.debug) {
                    console.log('%c sceneController %c plotTransform() deleted from plottables', me.debugPrimary, me.debugSecondary, t);
                }
            }
            me.applicationEvents.triggerEnd(token, t, me.__ID);
            resolve(t);
        });
    }
    resetAllTransforms() {
        // danger; it will reset all Transforms in the scene, including those who's not currently showing. Needs a better check if it's currently displaying or not before reset.
        if (this.mapService.sceneTransforms && this.mapService.sceneTransforms.length) {
            this.mapService.sceneTransforms.forEach(t => {
                this.resetTransform(t);
            });
        }
    }
    resetTransform(t) {
        let me = this;
        delete t['issues'];
        delete t['__detected'];
        delete t['__properties'];
        t.saveObservable().subscribe();
        return new Promise(resolve => {
            me.mapService.helper.removePlottable(t);
            let args = {
                onInit: function (T, S) { me.callback('init', T, S); },
                onStart: function (T, S) { me.callback('start', T, S); },
                onProcess: function (T, S) { me.callback('process', T, S); },
                onDuring: function (T, S) { me.callback('during', T, S); },
                onEnd: function (T, S) { me.callback('end', T, S); }
            };
            if (t.transformType.uid == 'kml' || t.transformType.uid == 'geo-json') {
                args['clamping'] = t['clamping'];
            }
            me.mapService.helper.setPlottable(t, args).subscribe(p => {
                setTimeout(() => { resolve(t); }, 400);
            });
        });
    }
    eventCatcher(e, name, collection, added, removed, changed) {
        if (e['inCallback']) {
            return;
        }
        e['inCallback'] = true;
        e.entities.suspendEvents();
        if (added && added.length) {
            console.log('%c [' + name + '] = [entities] collection event', Constants_1.Constants._orange, e['inCallback'], added, removed, changed);
        }
        e.entities.resumeEvents();
    }
    checkAndHook(e, token, t) {
        const c = e ? (e.constructor ? e.constructor.name : 'any') : 'none';
        let extra = '-' + token;
        ['id', '_id', 'name', '_name'].forEach(key => {
            if (e && e[key]) {
                extra += '-' + key + ':' + e[key];
            }
        });
        const id = c + ':' + typeof e + extra;
        // console.log('%c ## checking ['+id+'] ', Constants._yellow, e );
        // events and hooks
        // 'tileFailed','tileLoad','tileUnload','tileVisible',
        ['loadingEvent', 'changedEvent', 'errorEvent', 'allTilesLoaded', 'initialTileLoaded', 'loadingProgress', 'errorEvent'].forEach(key => {
            if (e[key]) {
                // console.log('%c ## ['+id+'] has ['+key+'] event', Constants._blue, e );
                e[key].addEventListener(function (aa, bb, cc) {
                    console.log('%c [' + id + '] = [' + key + '] event', Constants_1.Constants._orange, aa, bb, cc);
                });
            }
        });
        // promises (function / object)
        if (e['then']) {
            e = { genericPromise: e };
        }
        ['getViewableRectangle', 'readyPromise', 'genericPromise'].forEach(key => {
            if (e[key]) {
                // console.log('%c ## ['+id+'] has ['+key+'] promise', Constants._blue, e );
                if (typeof e[key] == 'function') {
                    // for functions that return a promise
                    e[key]().then(function (aa, bb, cc) {
                        console.log('%c [' + id + '] = [' + key + '] promise function', Constants_1.Constants._orange, aa, bb, cc);
                    });
                }
                else {
                    // for objects that are Promises
                    e[key].then(function (aa, bb, cc) {
                        console.log('%c [' + id + '] = [' + key + '] promise object', Constants_1.Constants._orange, aa, bb, cc);
                    });
                }
            }
        });
    }
    reportComplexAction(id, data) {
        const t = new Date();
        const now = t.toUTCString();
        // console.log('**** COMPLEX LOGGING', now, id, data );
        this.complexActionLog.push({ time: now, id: id, data: data });
    }
    sendReport() {
        // pick last 10 items
        const these = _.takeRight(this.complexActionLog, 10);
        console.log('**** COMPLEXITY REPORT, LAST 10', these);
    }
    report(who, what, state) {
        if (what == States_1.A.TRANSPARENT_TERRAIN) {
            if (!this.transparentTerrains[who]) {
                this.transparentTerrains[who] = null;
            }
            this.transparentTerrains[who] = state;
            this.anyTransparentTerrain = this.check(this.transparentTerrains);
        }
        else if (what == States_1.A.TRANSPARENT_ITEM) {
            if (!this.transparentItems[who]) {
                this.transparentItems[who] = null;
            }
            this.transparentItems[who] = state;
            this.anyTransparentItems = this.check(this.transparentItems);
        }
        else if (what == States_1.A.POINTCLOUD) {
            if (!this.pointClouds[who]) {
                this.pointClouds[who] = null;
            }
            this.pointClouds[who] = state;
            this.anyPointclouds = this.check(this.pointClouds);
        }
        else if (what == States_1.A.TERRAIN) {
            if (!this.terrains[who]) {
                this.terrains[who] = null;
            }
            this.terrains[who] = state;
            this.anyTerrain = this.check(this.terrains);
        }
        // are we picking pointclouds?
        this.measureHelper.pickingPointclouds = this.anyPointclouds;
        // are we picking transparent objects?
        this.measureHelper.pickingTransparent = this.anyTransparentItems;
        // are we picking on a transparent terrain?
        this.measureHelper.pickingTransparentTerrain = this.anyTransparentTerrain;
        // if there's anything transparent in the scene, enable picking from them
        let transpick = this.anyTransparentItems || this.anyTransparentTerrain;
        this.mapService.viewer.scene.pickTranslucentDepth = transpick;
        if (this.debugReport) {
            console.log('%c sceneController %c report()', this.debugPrimary, this.debugSecondary, who, what, state);
        }
        if (this.debugReport) {
            console.log('%c sceneController %c report() STATE', this.debugPrimary, this.debugSecondary, this.anyPointclouds, this.anyTransparentItems, this.anyTransparentTerrain, transpick);
        }
    }
    check(list) {
        let state = false;
        Object.keys(list).forEach(key => {
            if (list[key]) {
                state = list[key];
            }
        });
        return state;
    }
    checkForCameraBookmarks(category, obj) {
        this.reportCameraBookmark(category, obj['id'], {
            global: { camera: obj ? obj['cameraPosition'] : null, isDefault: false },
            user: { camera: obj && obj.props ? obj.props['cameraPosition'] : null, isDefault: false },
            obj: obj
        });
    }
    removeCameraBookmarks(category, obj) {
        if (this.activeCameraPositions[category] && obj) {
            this.activeCameraPositions[category] = this.activeCameraPositions[category].filter(rm => rm.id !== obj.id);
        }
    }
    fetchCameraBookmark() {
        let ret = { category: null, camera: null, id: null };
        let c = this.activeCameraPositions;
        ['project', 'scene', 'transform'].forEach(key => {
            if (c[key]) {
                if (c[key].length) {
                    c[key].forEach(cc => {
                        ['global'].forEach(who => {
                            if (cc.data[who].camera) {
                                ret.camera = cc.data[who].camera;
                                ret.category = key;
                                ret.id = cc.data.obj['id'];
                            }
                        });
                    });
                }
            }
        });
        return ret;
    }
    reportCameraBookmark(category, id, data = null) {
        if (!this.activeCameraPositions[category]) {
            this.activeCameraPositions[category] = [];
        }
        this.activeCameraPositions[category].push({ category: category, id: id, captured: false, isDefault: false, idx: this.activeCameraPositions.counter, data: data });
        this.activeCameraPositions.counter++;
    }
    flyTo(data) {
        if (data instanceof _4d_mapper_1.Transform) {
            this.flyToTransform(data);
        }
        else {
            this.flyToCamera(data);
        }
    }
    flyToTransform(t) {
        this._snackBar.open("Flying to Transform '" + t.name + "'");
        this.mapService.helper.sendCameraTo(t);
        setTimeout(() => { this._snackBar.dismiss(); }, 3000);
    }
    flyToCamera(details = null) {
        if (!details) {
            // console.log('@flyTo noCoords',details);
            return null;
        }
        let fly = { destination: null };
        // is it default position (Cartesian3) of a position?
        if (details['x'] && details['y']) {
            fly.destination = details;
        }
        if (details['position']) {
            fly.destination = details.position;
        }
        if (details['direction'] && details['up']) {
            fly['orientation'] = {
                direction: details.direction,
                up: details.up
            };
        }
        // console.log('@@flyTo()', details, fly);
        if (fly.destination && this.mapService.viewer) {
            this._snackBar.open("Flying to Camera position");
            this.mapService.viewer.camera.flyTo(fly);
            setTimeout(() => { this._snackBar.dismiss(); }, 3000);
        }
    }
    setCamera(details = null) {
        // console.log('!! setCamera()', details );
        let camera = this.mapService.viewer.camera;
        if (details.position && details.position.x !== 0)
            camera.position = details.position;
        if (details.direction && details.direction.x)
            camera.direction = details.direction;
        if (details.up && details.up.x)
            camera.up = details.up;
        if (details.right && details.right.x)
            camera.right = details.right;
        // if (details.frustrum )
        //   camera.frustrum = details.frustrum;
    }
    getCamera() {
        // we need to deep clone these, otherwise they're just passed by reference and screws things up
        let camera = this.mapService.viewer.camera;
        let ret = {
            position: _.cloneDeep(camera.position),
            direction: _.cloneDeep(camera.direction),
            up: _.cloneDeep(camera.up),
            right: _.cloneDeep(camera.right),
        };
        // console.log('!! getCamera()', ret );
        return ret;
    }
}
SceneControllerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SceneControllerService_Factory() { return new SceneControllerService(i0.ɵɵinject(i1.XsApplicationEventsService), i0.ɵɵinject(i2.MapService), i0.ɵɵinject(i3.FeatureDetectorService), i0.ɵɵinject(i4.MeasurementHelperService), i0.ɵɵinject(i5.MatSnackBar)); }, token: SceneControllerService, providedIn: "root" });
exports.SceneControllerService = SceneControllerService;
// Camera class for future handling (not implemented yet)
class Camera {
}
exports.Camera = Camera;
